import { FC } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useWindowStore } from 'modules/desktop/pages/MainPage/stores'
import Helmet from 'react-helmet'
import { useLocation } from 'react-router-dom'

import { APP_META_TAGS_DATA } from './AppMetaTag.constants'

export const AppMetaTag: FC = () => {
  const { activeWindowId } = useWindowStore()
  const { pathname } = useLocation()
  const isInDetachedMode = pathname !== '/'
  const { apps } = useAvailableApps()

  let metaData = { title: 'Desktop', faviconPathName: 'clusterix' }

  if (isInDetachedMode) {
    const matchedApp = Object.values(apps)
      .sort((a, b) => b.path.length - a.path.length)
      .find(appConfig => {
        return (
          pathname === appConfig.path ||
          pathname.startsWith(`${appConfig.path}/`)
        )
      })

    if (matchedApp) {
      metaData = APP_META_TAGS_DATA[matchedApp.id] ?? metaData
    }
  } else if (activeWindowId) {
    const windowMetaData = APP_META_TAGS_DATA[activeWindowId as AppId]
    if (windowMetaData) {
      metaData = windowMetaData
    }
  }

  const { title, faviconPathName } = metaData

  return (
    <Helmet>
      <title>Clusterix {title ? `- ${title}` : ''}</title>
      <link
        rel='icon'
        type='image/x-icon'
        href={`/apps-meta-tags/${faviconPathName}/favicon.ico`}
      />
      <link
        rel='icon'
        type='image/png'
        sizes='16x16'
        href={`/apps-meta-tags/${faviconPathName}/favicon-16x16.png`}
      />
      <link
        rel='icon'
        type='image/png'
        sizes='32x32'
        href={`/apps-meta-tags/${faviconPathName}/favicon-32x32.png`}
      />
      <link
        rel='apple-touch-icon'
        sizes='180x180'
        href={`/apps-meta-tags/${faviconPathName}/apple-touch-icon.png`}
      />
    </Helmet>
  )
}
